/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-danger,jsx-a11y/iframe-has-title */
import React from 'react';
import PropTypes from 'prop-types';
import {filterHTML} from "../../helpers/filters";
import ReactVideoModal from "../ReactVideoModal/ReactVideoModal"
import './VideoCallout.scss';

const VideoCallout = ({videoUrl, title, thumbnailFileName, thumbnailUrl}) => {
    const [videoIsOpen, setVideoIsOpen] = React.useState(false);

    let thumbnail = '';
    if (thumbnailUrl) thumbnail = thumbnailUrl;
    else if (thumbnailFileName) thumbnail = `/public/images/htmlComponents/videoCallout/${filterHTML(thumbnailFileName)}.png`;

    return (
        <div className="videoCallout">
    
            {title && (
                <h2>{filterHTML(title)}</h2>
            )}
    
            <div className="videoCallout__wrapper" role="button" onClick={() => {
                setVideoIsOpen(!videoIsOpen);
            }}>

                <img className="videoCallout__thumbnail" src={thumbnail} alt=""/>
    
                <div className="videoCallout__playButton">
                    <svg enableBackground="new 0 0 85 85" viewBox="0 0 85 85" xmlns="http://www.w3.org/2000/svg"><g fill="#fff"><path d="m42.5 0c-23.5 0-42.5 19-42.5 42.5s19 42.5 42.5 42.5 42.5-19 42.5-42.5-19-42.5-42.5-42.5zm0 77.7c-19.5 0-35.2-15.7-35.2-35.2s15.7-35.2 35.2-35.2 35.2 15.7 35.2 35.2-15.7 35.2-35.2 35.2z"/><path d="m32.1 61.6 31.5-19.1-31.5-19.1z"/></g></svg>
                </div>
            </div>
    
            <ReactVideoModal inline={false} uri={filterHTML(videoUrl)} isOpen={videoIsOpen} onClose={() => {
                setVideoIsOpen(!videoIsOpen);
            }}/>
        </div>
    
    );
}

VideoCallout.propTypes = {
    title: PropTypes.string,
    videoUrl: PropTypes.string,
    thumbnailFileName: PropTypes.string,
    thumbnailUrl: PropTypes.string,
};

VideoCallout.defaultProps = {
    title: '',
    videoUrl: '',
    thumbnailFileName: '',
    thumbnailUrl: '',
};

export default VideoCallout;



// WEBPACK FOOTER //
// ./frontend/components/VideoCallout/VideoCallout.jsx